import { ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full.js';
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import { changePasswordService } from '@/app/shared/services/change-password-service.js'
import { showPopupNotification } from "@/app/shared/grid-functionality/grid-functionality.js";
import router from '@/app/app-routes'
import { loginService } from "@/app/shared/services/loginService.js";

localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('./theme/change-password.scss') : import('./theme/change-password-rtl.scss');

//Module localization 
import localeEn from '../../../../locales/en'
import localeAr from '../../../../locales/ar'

export default {
    name: 'change-password-form',
    data() {
        return {
            hideNotification: 5000,

            formData: {
                currentPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            },
            isLoading: false,
            iscurrentPasswordShow: false,
            isConfirmtPasswordShow: false,
            isNewPasswordShow: false,
            passwordFieldType: 'password',
            textFieldType: 'text',
            ShowErrorMsg: false,
            showText: "Show",
            hideText: "Hide",
            ChangePasswordStatusEnum: {
                Success: 1,
                Failure: 2,
                PasswordMismatch: 3,
                AuthenticationTypeChanged: 4
            }
        }
    },
    methods: {
        async submit() {
             
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                 
                this.isLoading = true;
                this.ShowErrorMsg = false;
                if (this.formData.newPassword != this.formData.confirmNewPassword) {
                    this.isLoading = false;
                    this.ShowErrorMsg = true;
                } else {
                    changePasswordService.changePassword(this.formData.currentPassword, this.formData.newPassword, "", (result) => {
                        console.log(result)
                        switch (result.data) {
                            case this.ChangePasswordStatusEnum.Success:
                                this.showPopupNotification(`${this.$i18n.t('Common.Success')}`, `${this.$i18n.t('Common.UpdatedSuccessfully')}`, `success`);
                                router.push('/dashboard');
                                location.reload();
                                break;

                            case this.ChangePasswordStatusEnum.Failure:
                                this.showPopupNotification(this.$i18n.t('Common.Failure'), this.$i18n.t('Common.SomethingWrong'), 'error');
                                break;

                            case this.ChangePasswordStatusEnum.PasswordMismatch:
                                this.showPopupNotification(this.$i18n.t('Common.Warning'), this.$i18n.t('Common.passwordErrorCurrent'), 'warning');
                                break;

                            case this.ChangePasswordStatusEnum.AuthenticationTypeChanged:
                                this.showPopupNotification(this.$i18n.t('Common.Warning'), this.$i18n.t('Common.AuthenticationTypeChanged'), 'warning');
                                localStorage.clear();
                                loginService.login("", "", (result) => {
                                    if (result != null && result.data.ResponseStatus == 200 && result.data.token != null) {
                                        result.data.token.NG_TRANSLATE_LANG_KEY = 'en';
                                        loginService.saveTokenInfo(result.data.token);
                                        this.$router.push('/dashboard');
                                        // rendering problem
                                        location.reload();
                                    }
                                    this.isLoading = false;
                                }, (error) => {
                                    console.log(error);
                                    this.isLoading = false;
                                });
                                break;
                        }
                        this.isLoading = false;

                    }, () => {
                        this.isLoading = false;
                        this.showPopupNotification(this.$i18n.t('Common.Failure'), this.$i18n.t('Common.SomethingWrong'), 'error');
                    })
                }
            }
            else {
                return
            }
        },
        showPopupNotification
    },
    mounted: function () {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();

    },
    components: {
        ValidationProvider,
        ValidationObserver,
        Loader
    },
    directives: {
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
};
